var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-soon"},[_c('i',{staticClass:"material-icons"},[_vm._v("construction")]),_c('p',[_vm._v(_vm._s(_vm.$t("mobile.comingSoon")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }